var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.078 21V11m0 0c-1.708 0-3.093-1.343-3.093-3s1.385-3 3.093-3m0 6c1.709 0 3.094-1.343 3.094-3s-1.385-3-3.094-3m0-2v2m-7.11-2v10m0 0c-1.708 0-3.093 1.343-3.093 3s1.385 3 3.093 3m0-6c1.708 0 3.093 1.343 3.093 3s-1.385 3-3.093 3m0 2v-2M19.032 3v8.055m0 0c-1.708 0-3.093 1.343-3.093 3s1.385 3 3.093 3m0-6c1.708 0 3.093 1.343 3.093 3s-1.385 3-3.093 3m0 3.945v-3.945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.d969e3d522139654e8e15dd8fb11d493.svg";
export { ForwardRef as ReactComponent };